import { render } from "./settledgamesdetail.vue?vue&type=template&id=156f3cb1"
import script from "./settledgamesdetail.vue?vue&type=script&lang=js"
export * from "./settledgamesdetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__